import React, { useState, useEffect } from "react";
import { BASE_URL } from "../utils/config";
import {  useNavigate } from "react-router-dom";
import Sidebar from "../components/sidebar";
import { Toolbar } from "primereact/toolbar";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import Loading from "../components/loading";
import IntervalRecord from "../components/stockintervalComponent";
import TelegramWidget from "../components/widget/telegramWidget";

const StockInterval = () => {
 const navigate = useNavigate();
  const [IndicesRecord, setIndicesRecord] = useState([]);

  const [loading, setLoading] = useState(true);

  const [value, setValue] = useState(0);
  const [IndicesRecordTab, setIndicesRecordTab] = useState(true);

  const [successDialog, setSuccessDialog] = useState(false);
  const [errorDialog, setErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [heading, setHeading] = useState('Telegram Automation Record')
  const [email,setEmail] = useState('');
  let count = 0;




  useEffect(() => {
    if (count === 0) {
      fetchrecord();
      const details = JSON.parse(localStorage.getItem('userdetails'));
      setEmail(details.email_address)
      count += 1;
    }
  }, []);

  const fetchrecord = async () => {
    console.log("inside fetch record ")
    const loginuser = JSON.parse(localStorage.getItem('loginData'));
    try {
      await fetch(`${BASE_URL}/getAllTelegramAutomation`, {
        method: "GET",
        headers: {
          'Authorization': `Bearer ${loginuser.token}`
        }
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.success === true) {
            console.log(
              "automate scritp date for record stock selection",
              res.telegramAutomation[0],
            );

            setIndicesRecord(res.telegramAutomation[0]);
        

            setHeading('Telegram Automation Record')
            setValue(0)
          
            setLoading(false);

            // console.log("lot_size",res.lot_size)
          }else if(res.status === 403){ 
            setTimeout(()=>{
              localStorage.clear()
               navigate('/login')
            },3000) 
          }
          else if(res.status === 401){
            setTimeout(()=>{
              localStorage.clear()
               navigate('/login')
            },3000) 
          } else {
            console.log("data not found");
            setLoading(false);
            setErrorMessage(`Error: ${res.message}`);
            setErrorDialog(true);
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage('')
            }, 2000);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
          setErrorMessage(`Error: ${error.message}`);
          setErrorDialog(true);
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage('')
          }, 2000);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true);
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage('')
      }, 2000);
    }
  };





  const centerToolbarTemplate = () => {
    return (
      <>
        <h2 style={{ marginTop: "0px" }}>{heading}</h2>
      </>
    );
  };




  const updateRecordData = (updatedRow) => {
    // Find and update the row in the RecordData
    
    setIndicesRecord((prevData) =>
        prevData.map((row) => (row.id === updatedRow.id ? updatedRow : row))
    );
};





  return (
    <>
      <Sidebar />
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
          }}
        >
          <Loading />
        </div>
      ) : (
        <div className="add-user user-list">
          <Toolbar
            className="table-pre-head"
        
          
            center={centerToolbarTemplate}
          ></Toolbar>
          {IndicesRecordTab ? (
            <IntervalRecord RecordData={IndicesRecord} heading={'Telegram Automation Record'} updaterecord={fetchrecord} Email={email} updateRecordData={updateRecordData}/>
          ) : null}

<TelegramWidget/>
          {/*Error Message Dialog */}
          <Dialog
            open={errorDialog}
            onClose={() => { setErrorDialog(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              <h4 style={{ color: "red" }}>Failure</h4>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">


                {errorMessage}


              </DialogContentText>
            </DialogContent>

          </Dialog>

          {/*Success Message Dialog */}
          <Dialog
            open={successDialog}
            onClose={() => { setSuccessDialog(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              <h4 style={{ color: "green" }}>Success</h4>

            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">


                <span style={{ color: "black" }}>
                  {successMessage}
                </span>


              </DialogContentText>
            </DialogContent>

          </Dialog>

       

        </div>
      )}
    </>
  );
};

export default StockInterval;
